import {dd,store,app} from 'systems/imports'
import BaseApi from 'api/BaseApi'
import { normalize, schema, Array } from 'normalizr';

//import { normalize, schema, Array } from 'normalizr';

/**
 * 運営サイト情報
 */
class AppTranslation extends BaseApi{
  static getClassName(){ return 'AppTranslation' }

  /**
   */
  static get(langCode){
    return app.make("axios").get(`v1/util/ui-translation/${langCode}`)
      .then(({data}) =>{
        return data.data
      })
      .catch(error => {
        console.log(error);
      })
  }
}

export default AppTranslation



// WEBPACK FOOTER //
// ./src/api/AppTranslation.js